<div class="flex-col">
    <cb-dialog dialogHeading="Document Upload">
        <div class="document-container flex-col">
            <form class="flex-col flex"
                  #documentUploadForm="ngForm">

                <!-- Show Only On Document Upload - NOT REUPLOAD -->
                @if (!data.isDocumentReupload) {
                    <div>
                        <mat-form-field>
                            <mat-label>Document Group</mat-label>
                            <mat-select [(value)]="selectedGroup"
                                        (selectionChange)="onGroupSelection($event.value)">
                                @for (group of availableForUploadDocumentGroups; track group) {
                                    <mat-option
                                        [value]="group">
                                        {{ group.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        @if (showTypeSelector) {
                            <mat-form-field>
                                <mat-label>Document Type</mat-label>
                                <mat-select [(value)]="selectedType"
                                            (selectionChange)="onTypeSelection($event.value)">
                                    @for (type of availableForUploadDocumentTypes; track type) {
                                        <mat-option
                                            [value]="type">
                                            {{ type.documentType.label }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        }
                    </div>
                }

                <!-- Show Only On Document Upload - NOT REUPLOAD -->
                <cb-document-upload [hidden]="!showDragDrop"
                                    class="cb-margin-bottom-2x"
                                    [documentEntityMappedItem]="data.documentEntityMappedItem">
                </cb-document-upload>
                @if (displayDocumentReviewSection()) {
                    <div>
                        <cb-select label="Document Review"
                                   [(ngModel)]="tempDocumentReviewDto.status"
                                   name="reveiwStatus"
                                   [required]="true"
                                   [options]="documentReviewStatuses">
                        </cb-select>
                        @if (tempDocumentReviewDto.status === DOCUMENT_REVIEW_STATUS_ENUM.Rejected) {
                            <cb-input class="cb-padding-top"
                                      name="rejectedReason"
                                      label="Rejected Reason"
                                      [required]="true"
                                      [(ngModel)]="tempDocumentReviewDto.comments">
                            </cb-input>
                        }
                    </div>
                }
            </form>
        </div>
        <div actions>
            <button mat-raised-button
                    color="primary"
                    class="save-button"
                    [disabled]="documentUploadForm.invalid"
                    (click)="onSubmit()">Upload
            </button>
            <button
                mat-raised-button
                (click)="cancel()">Close
            </button>
        </div>

    </cb-dialog>
</div>
